
import React from "react";

export const EthereumIcon = ({ 
  className, 
  size = 24, 
  color = "currentColor", 
  strokeWidth = 2,
  ...props 
}: React.SVGProps<SVGSVGElement> & {
  size?: number;
  color?: string;
  strokeWidth?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <path d="M12 2L3 12.5L12 16" />
      <path d="M12 2L21 12.5L12 16" />
      <path d="M3 12.5L12 22L21 12.5" />
      <path d="M12 16L12 22" />
    </svg>
  );
};

export default EthereumIcon;
